<template>
    <div class="container lists__container">
        <h2 class="section-title lists__title">My Lists</h2>
        <p class="lists__text">
            Keep favorite items organized and ready-to-order.
        </p>
        <div class="lists__boxes">
            <Create v-on:checkLoader="checkLoader" />
            <MainList
                :favorites="favorites"
                :recommendations="recommendations"
                :viewed="viewed"
                :kadraGlobal="kadraGlobal"
            />
        </div>
        <div class="lists__user-boxes">
            <div v-if="loader" class="lists__user-boxes-loader">
                <div class="loader"></div>
            </div>
            <Lists
                v-show="loader === false"
                :wishRender="wishRender"
                :kadraGlobal="kadraGlobal"
            />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Lists from './Parts/Lists.vue';
import Create from './Parts/Create.vue';
import MainList from './Parts/MainList.vue';

export default {
    computed: mapState({
        list: state => state.List.list,
        wishlist: state => state.List.wishlist,
        recommendations: state => state.List.recommendations,
        viewed: state => state.List.viewed
    }),
    components: {
        Lists,
        Create,
        MainList
    },
    data() {
        return {
            wishRender: [],
            kadraGlobal: kadraGlobal,
            favorites: {
                count: 0
            },
            loader: true
        };
    },
    beforeMount() {
        //this.$store.dispatch('getList');
        //this.$store.dispatch('getRecommendations');
        //this.$store.dispatch('getViewed');
        this.$store.commit('SET_LIST', window.fwsWishlistHomePack.list);
        this.$store.commit('SET_RECOMMENDATIONS', window.fwsWishlistHomePack.recommend);
        this.$store.commit('SET_VIEWED', window.fwsWishlistHomePack.viewed);
        this.$store.commit('SET_WISHLIST_LIST', window.fwsWishlistHomePack.wishlist);
    },
    watch: {
        list() {
            this.loader = false;
            this.setFavorites();
        },
        wishlist() {
            this.loader = false;
            this.setCount();
            const ele = document.getElementById('countList');
            if (this.wishlist.length !== 0 && ele) {
                ele.style.display = 'flex';
                ele.innerHTML = this.wishlist.length;
            }
        }
    },
    methods: {
        checkLoader() {
            this.loader = true;
        },
        setCount() {
            const arr = [];
            this.wishlist.forEach(element => {
                const duplicates = [];
                element.count = 0;
                element.created_at
                    ? (element.date = this.setDate(element.created_at))
                    : (element.date = this.setDateIfNotEx());
                this.list.forEach(item => {
                    if (!item.restricted) {
                        if (element.ID === item.status) {
                            if (!duplicates.includes(item.product_id)) {
                                element.count++;
                            }
                            duplicates.push(item.product_id);
                        }
                    }
                });
                arr.push(element);
            });
            this.wishRender = arr;
        },
        setDate(date) {
            if (date !== undefined) {
                const spl = date.split(' ');
                return spl[0];
            }
        },
        setDateIfNotEx() {
            const d = new Date();
            const mounth = d.getMonth() + 1;
            return d.getFullYear() + '-' + mounth + '-' + d.getDate();
        },
        setFavorites() {
            const obj = {};
            obj.count = 0;
            const duplicates = [];
            this.list.forEach(item => {
                if (!item.restricted) {
                    if (item.status === 'favorites') {
                        if (duplicates.indexOf(item.product_id) === -1) {
                            obj.count++;
                        }
                        duplicates.push(item.product_id);
                    }
                }
            });
            this.favorites = obj;
        }
    }
};
</script>

<style lang="scss" scoped>
.lists__user-boxes {
    position: relative;
}

.lists__user-boxes-loader {
    position: absolute;
    top: 0;
    left: 0;
    height: 100px;
    width: 100%;

    .loader {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 50px;
    }

    @include mq(1024px) {
        position: fixed;
        height: 100%;
        width: 100%;
        background-color: rgba($black, 0.2);
        display: flex;
        justify-content: center;
        align-items: center;

        .loader {
            position: static;
        }
    }
}
</style>
